export default __webpack_public_path__ + "static/media/image.the-search-bar.3e54e01d.png";